export const META_PIXEL_ID = '2160428594562418'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

const SCRIPT_ID = 'meta-pixel-script'
const NOSCRIPT_ID = 'meta-pixel-noscript'

/**
 * Loads the Meta Pixel base code and fires the initial PageView.
 * Safe to call more than once — it never injects twice.
 */
export function initMetaPixel(pixelId: string = META_PIXEL_ID) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  if (!window.fbq) {
    const fbq: Window['fbq'] = function (...args: unknown[]) {
      if (fbq!.callMethod) fbq!.callMethod(...args)
      else fbq!.queue!.push(args)
    } as Window['fbq']

    fbq!.queue = []
    fbq!.push = fbq
    fbq!.loaded = true
    fbq!.version = '2.0'

    window.fbq = fbq
    window._fbq = fbq
  }

  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  if (!document.getElementById(NOSCRIPT_ID)) {
    const noscript = document.createElement('noscript')
    noscript.id = NOSCRIPT_ID
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" alt="" />`
    document.body.appendChild(noscript)
  }

  window.fbq?.('init', pixelId)
  window.fbq?.('track', 'PageView')
}

/** Fires a standard or custom Meta Pixel event. */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
) {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}
